var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v("\n                Edit Profile\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "changeProfile" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.firstName,
                            expression: "firstName"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "firstName",
                          placeholder: "First Name"
                        },
                        domProps: { value: _vm.firstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.firstName = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.firstName))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lastName,
                            expression: "lastName"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "lastName",
                          placeholder: "Last Name"
                        },
                        domProps: { value: _vm.lastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.lastName = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.lastName))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "email",
                          placeholder: "Email"
                        },
                        domProps: { value: _vm.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.email))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c(
                      "span",
                      {
                        staticClass: "form-control",
                        model: {
                          value: _vm.username,
                          callback: function($$v) {
                            _vm.username = $$v
                          },
                          expression: "username"
                        }
                      },
                      [_vm._v(_vm._s(_vm.username))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            name: "reportTo",
                            id: "reportTo",
                            label: "text",
                            filterable: false,
                            options: _vm.reportToArr,
                            placeholder: "Select User"
                          },
                          on: {
                            change: _vm.changedValue,
                            input: function($event) {
                              return _vm.changedValueUser()
                            },
                            search: _vm.onSearchUser
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "option",
                              fn: function(option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _vm._v(
                                      "\n                                                " +
                                        _vm._s(option.text) +
                                        "\n                                            "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "selected-option",
                              fn: function(option) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "selected d-center" },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(option.text) +
                                          "\n                                            "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.reportTo,
                            callback: function($$v) {
                              _vm.reportTo = $$v
                            },
                            expression: "reportTo"
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(
                              "\n                                            Search User...\n                                        "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.reportToError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c(
                      "span",
                      {
                        staticClass: "form-control",
                        model: {
                          value: _vm.locationId,
                          callback: function($$v) {
                            _vm.locationId = $$v
                          },
                          expression: "locationId"
                        }
                      },
                      [_vm._v(_vm._s(_vm.locationId))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phone,
                            expression: "phone"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "phone",
                          placeholder: "Phone"
                        },
                        domProps: { value: _vm.phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.phone = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.phoneError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.post,
                            expression: "post"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "post",
                          placeholder: "Post"
                        },
                        domProps: { value: _vm.post },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.post = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.postError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.teamDesignation,
                            expression: "teamDesignation"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "teamDesignation",
                          placeholder: "Team Designation"
                        },
                        domProps: { value: _vm.teamDesignation },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.teamDesignation = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.teamDesignationError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.bio,
                          expression: "bio"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "bio", placeholder: "Bio" },
                      domProps: { value: _vm.bio },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.bio = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm.loginId != _vm.user_id
                  ? _c("div", { staticClass: "col-6 forms-block" }, [
                      _vm._m(10),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 paddingleft0" },
                        [
                          _c("v-select", {
                            attrs: {
                              name: "roleId",
                              id: "roleData",
                              label: "text",
                              searchable: false,
                              filterable: false,
                              options: _vm.roleArr,
                              placeholder: "Select Role"
                            },
                            model: {
                              value: _vm.roleId,
                              callback: function($$v) {
                                _vm.roleId = $$v
                              },
                              expression: "roleId"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(11),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("tinymce", {
                        ref: "tm",
                        attrs: {
                          plugins: [
                            "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                            "searchreplace wordcount visualblocks visualchars code fullscreen",
                            "insertdatetime media nonbreaking save table contextmenu directionality",
                            "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                          ],
                          id: "description"
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.frontendErrors.descriptionError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(12),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("date-picker", {
                        staticClass: "form-control",
                        attrs: {
                          id: "dateofBith",
                          config: _vm.configCalendar,
                          placeholder: "Enter Date of Birth",
                          name: "dateofBith"
                        },
                        model: {
                          value: _vm.dateofBith,
                          callback: function($$v) {
                            _vm.dateofBith = $$v
                          },
                          expression: "dateofBith"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(13),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quote,
                          expression: "quote"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "quote",
                        placeholder: "Quote"
                      },
                      domProps: { value: _vm.quote },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.quote = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(14),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quoteName,
                          expression: "quoteName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "quoteName",
                        placeholder: "Quote Name"
                      },
                      domProps: { value: _vm.quoteName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.quoteName = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("vue-dropzone", {
                        ref: "dropzone",
                        attrs: {
                          id: "drop1",
                          options: _vm.dropzoneOptions,
                          destroyDropzone: false,
                          headers: _vm.dropzoneOptions.headers,
                          name: "file"
                        },
                        on: {
                          "vdropzone-removed-file": _vm.removedSelectedFile,
                          "vdropzone-success": _vm.vfileSuccess
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _c("strong", {
                          staticClass: "error text-danger",
                          attrs: { id: "uploadErrorMsg" }
                        })
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 paddingleft0" },
                    [
                      _c("vue-croppie", {
                        ref: "croppieRef",
                        attrs: {
                          id: "vuecrop",
                          viewport: { width: 276, height: 312, type: "square" },
                          boundary: { width: 286, height: 322 },
                          enableResize: false
                        },
                        on: { result: _vm.result, update: _vm.update }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 paddingleft0" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn-croppie",
                          attrs: {
                            id: "rotateAnti",
                            type: "button",
                            title: "Rotate Left"
                          },
                          on: {
                            click: function($event) {
                              return _vm.rotate(-90)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-repeat",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-croppie",
                          attrs: {
                            id: "rotateClock",
                            type: "button",
                            title: "Rotate Right"
                          },
                          on: {
                            click: function($event) {
                              return _vm.rotate(90)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-undo",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-croppie",
                          attrs: { id: "crop", type: "button", title: "Crop" },
                          on: {
                            click: function($event) {
                              return _vm.crop()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-crop",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("img", { attrs: { src: _vm.cropped, width: "200" } }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.cropError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "col-12 paddingleft0" }, [
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit", value: "Save", id: "save" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changeProfile()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        value: "Change Password",
                        id: "change_password",
                        "data-toggle": "modal",
                        "data-target": "#changePassword"
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal fade",
                    attrs: { id: "changePassword", role: "dialog" }
                  },
                  [
                    _c("div", { staticClass: "modal-dialog" }, [
                      _c("div", { staticClass: "modal-content" }, [
                        _vm._m(16),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "oldPassword" } }, [
                                  _vm._v("Old Password")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.oldPassword,
                                      expression: "oldPassword"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "oldPassword",
                                    type: "text",
                                    placeholder: "",
                                    name: "oldPassword"
                                  },
                                  domProps: { value: _vm.oldPassword },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.oldPassword = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.frontendErrors.oldPassword))
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "newPassword" } }, [
                                  _vm._v("New Password")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newPassword,
                                      expression: "newPassword"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "newPassword",
                                    type: "text",
                                    placeholder: "",
                                    name: "newPassword"
                                  },
                                  domProps: { value: _vm.newPassword },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.newPassword = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.frontendErrors.newPassword))
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "cpassword" } }, [
                                  _vm._v("Confirm Password")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.cpassword,
                                      expression: "cpassword"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "cpassword",
                                    type: "text",
                                    placeholder: "",
                                    name: "cpassword"
                                  },
                                  domProps: { value: _vm.cpassword },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.cpassword = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("font", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.frontendErrors.cpassword))
                                ])
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _vm._m(17),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.changePassword()
                                  }
                                }
                              },
                              [_vm._v("Save")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "firstName" } }, [
        _vm._v("First Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "lastName" } }, [
        _vm._v("Last Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "email" } }, [
        _vm._v("Email :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "username" } }, [
        _vm._v("Day Force Id :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "username" } }, [
        _vm._v("Reporting To :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationId" } }, [
        _vm._v("State :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "phone" } }, [
        _vm._v("Phone :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "post" } }, [
        _vm._v("Post :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", attrs: { for: "teamdesignation" } },
        [_vm._v("Team Designation :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "bio" } }, [
        _vm._v("Bio :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "roleData" } }, [
        _vm._v("Role :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Description :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "quote" } }, [
        _vm._v("Date of Birth :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "quote" } }, [
        _vm._v("Quote :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "phone" } }, [
        _vm._v("Quote Name :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop1" } }, [
        _vm._v("Profile Picture :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [_vm._v("Change Password")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            id: "changePasswordModel",
            "data-dismiss": "modal"
          }
        },
        [_vm._v("×")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
        [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2087b9e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2087b9e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/user/ChangeProfile.vue
// module id = null
// module chunks = 